import { render, staticRenderFns } from "./RequisitionSelector.vue?vue&type=template&id=23c0b6f4&scoped=true&"
import script from "./RequisitionSelector.vue?vue&type=script&lang=js&"
export * from "./RequisitionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c0b6f4",
  null
  
)

export default component.exports